<h3>{{ 'orderCost.orderSummary' | cxTranslate }}</h3>
<div *ngIf="cart">
  <ng-container *ngFor="let subTotal of cart.cartSubTotals || cart.subtotals">
    <div class="eb-summary-row" *ngIf="subTotal?.value > 0">
      <div class="col-6 eb-summary-label">
        {{ subTotal?.textId || subTotal?.labelTextId | cxTranslate }}
      </div>
      <div class="col-6 eb-summary-amount">
        {{
          subTotal?.value?.value > 0 || subTotal?.value > 0
            ? subTotal?.formattedValue || subTotal?.value?.formattedValue
            : ('prices.priceOnRequest' | cxTranslate)
        }}
      </div>
    </div>
  </ng-container>
  <div
    class="eb-summary-row eb-summary-total"
    *ngIf="cart.additionalTextId; else withoutAdditionalText"
  >
    <div class="eb-summary-label asterisk">
      {{ cart.totalPrice?.textId | cxTranslate }}
    </div>
    <div class="ml-2 eb-summary-amount">
      {{
        cart.totalPrice?.value > 0
          ? cart.totalPrice?.formattedValue
          : ('prices.priceOnRequest' | cxTranslate)
      }}
    </div>
    <div class="col-12 eb-summary-label additional-text">
      {{ cart.additionalTextId | cxTranslate }}
    </div>
  </div>
  <ng-template #withoutAdditionalText>
    <div class="eb-summary-row eb-summary-total">
      <div class="col-6 eb-summary-label">
        {{ cart.totalPrice?.textId || cart?.priceTotalTextId | cxTranslate }}
      </div>
      <div class="col-6 eb-summary-amount">
        {{
          cart.totalPrice?.value > 0 || cart?.priceTotalValue?.value > 0
            ? cart.totalPrice?.formattedValue || cart?.priceTotalValue?.formattedValue
            : ('prices.priceOnRequest' | cxTranslate)
        }}
      </div>
    </div>
  </ng-template>
</div>
